import { requestApiJson } from './client';

// 未読メンション在否（event / group）。バッジを黄色（メンション色）にするか判定する。
// backend: GET /api/chat/mention-unread-summary（セッションで admin/artist を自動判定）。
export async function getChatMentionUnreadSummary(): Promise<{ event: boolean; group: boolean }> {
  const { data } = await requestApiJson('/chat/mention-unread-summary', { method: 'GET' });
  return {
    event: Boolean((data as { event?: unknown } | null)?.event),
    group: Boolean((data as { group?: unknown } | null)?.group),
  };
}
